var PartnerSearchResultType;
(function(PartnerSearchResultType) {
    PartnerSearchResultType[PartnerSearchResultType["Industry"] = 0] = "Industry";
    PartnerSearchResultType[PartnerSearchResultType["Product"] = 1] = "Product";
    PartnerSearchResultType[PartnerSearchResultType["Service"] = 2] = "Service";
    PartnerSearchResultType[PartnerSearchResultType["Category"] = 3] = "Category";
    PartnerSearchResultType[PartnerSearchResultType["AdvSpec"] = 4] = "AdvSpec";
    PartnerSearchResultType[PartnerSearchResultType["Partner"] = 5] = "Partner";
    PartnerSearchResultType[PartnerSearchResultType["FreeText"] = 6] = "FreeText";
    PartnerSearchResultType[PartnerSearchResultType["Designation"] = 7] = "Designation";
    PartnerSearchResultType[PartnerSearchResultType["DiversityAndInclusion"] = 8] = "DiversityAndInclusion";
    PartnerSearchResultType[PartnerSearchResultType["AzureMSP"] = 9] = "AzureMSP";
})(PartnerSearchResultType || (PartnerSearchResultType = {}));
var allowedCountries = [
    'United States',
    'Canada',
    'United Kingdom',
    'India',
    'Australia',
    'Brazil',
    'Germany'
];

export { PartnerSearchResultType, allowedCountries };
